module.exports = __webpack_public_path__ + "static/donateImg-e6c87c3ef80ed18631e58cdbd2cbb59d.jpg";